import { render } from "./InformationComponent.vue?vue&type=template&id=2399109a"
import script from "./InformationComponent.vue?vue&type=script&lang=js"
export * from "./InformationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__